/**
 * @fileoverview FeaturedTourCard.jsx
 * 
 * © 2026 KITH Travels (Pvt) Ltd. All rights reserved.
 * This software is the confidential and proprietary information of KITH Travels.
 * You shall not disclose such Confidential Information and shall use it only in 
 * accordance with the terms of the license agreement you entered into with KITH Travels.
 */
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import DynamicImage from '../ui/DynamicImage'

function FeaturedTourCard({tour}) {
    const [loading, setLoading] = useState(true);
  return (
    <Link to={`/tours/${tour.slug || tour.id}`} className='block h-full aspect-[3/4] relative rounded-[2rem] overflow-hidden shadow-xl group cursor-pointer border border-white/10 shrink-0'>
        <DynamicImage 
            loading={loading} 
            setLoading={setLoading} 
            HighImage={tour.image.h} 
            LowImage={tour.image.l} 
            alt={`Tour: ${tour.name} - ${tour.category} in Sri Lanka`}
        />
        
        {/* Overlay gradient */}
        <div className='absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent group-hover:via-black/40 transition-all duration-300'></div>
        
        {/* Category Tag */}
        <div className='absolute top-4 right-4'>
            <span className='px-3 py-1 bg-KITH-primary text-white text-[10px] font-bold rounded-full uppercase tracking-widest shadow-lg'>
                {tour.category}
            </span>
        </div>

        {/* Content */}
        <div className='absolute bottom-0 left-0 w-full p-6 text-left flex flex-col gap-1 translate-y-2 group-hover:translate-y-0 transition-transform duration-300'>
            <h3 className='text-white text-xl font-bold leading-tight group-hover:text-KITH-primary transition-colors'>
                {tour.name}
            </h3>
            <p className='text-white/70 text-xs font-medium'>
                {tour.duration} Days | {tour.duration - 1} Nights
            </p>
            <div className='flex justify-between items-end mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
                <p className='text-white text-lg font-bold'>
                    USD {tour.price.toLocaleString()}.00 
                    <span className='text-[10px] font-normal text-white/60 ml-1'>/pp</span>
                </p>
                <div className='w-8 h-8 bg-KITH-primary rounded-full flex items-center justify-center text-white shadow-lg'>
                    <i className='fi fi-br-arrow-right text-xs'></i>
                </div>
            </div>
        </div>
    </Link>
  )
}

export default FeaturedTourCard